/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuspendGlycemicAliases {
  DT_CURRENT_TIME = 'dt-current-time',
  DT_CURRENT_TIME_INPUT = 'dt-current-time-input',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_TEXT_AREA_JUSTIFICATION = 'field-text-area-justification',
  FORM_GLYCEMIC_SUSPEND = 'form-glycemic-suspend',
  GLYCEMIC_SUSPEND_CONTEXTUAL_BAR = 'glycemic-suspend-contextual-bar',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_SUSPEND_CONTENT = 'layout-suspend-content',
  LAYOUT_SUSPEND_GLYCEMIC = 'layout-suspend-glycemic',
  MEDICATION_INFO_FRAGMENT = 'medication-info-fragment',
  PANEL_GLYCEMIC_SUSPEND_CONTENT = 'panel-glycemic-suspend-content',
  PANEL_SUSPEND_GLYCEMIC = 'panel-suspend-glycemic',
  TEXT_AREA_JUSTIFICATION = 'text-area-justification',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
}
export { SuspendGlycemicAliases };
